<div class="card dialog-box">
  <div class="card-header">
    <span class="float-end" (click)="onCloseDialog(false)">
      <i class="fa-solid fa-xmark"></i>
    </span>
  </div>
  <div class="fs-6 my-3 fw-semibold ps-2">Scan Options</div>
  <div class="d-flex flex-column gap-3 mb-5">
    @for (item of ["scan_gps", "scan_qr", "scan_nfc"]; track $index) {
      <div class="d-flex align-items-center ps-4 gap-3 p-2">
        <input
          class="form-check-input"
          [id]="item"
          type="checkbox"
          [checked]="scanPreferences?.[item]"
          (change)="scanPreferences[item] = !scanPreferences?.[item]"
          [disabled]="
            scanPreferences?.[item] &&
            +scanPreferences?.scan_gps +
              +scanPreferences?.scan_qr +
              +scanPreferences?.scan_nfc ===
              1
          "
        />

        @if (item == "scan_gps") {
          <span> <i class="fa-solid fa-location-dot"></i> </span>
          <label [for]="item" class="fs-6"> Geolocation-Photo </label>
        } @else if (item == "scan_qr") {
          <img
            src="assets/images/qr-code-logo.avif"
            alt="QR Code"
            width="26"
            class="mb-0 bg-white p-1 rounded"
          />

          <label [for]="item" class="fs-6"> QR </label>
        } @else {
          <img
            src="assets/images/NFC_logo.avif"
            alt="NFC Code"
            width="26"
            class="mb-0 bg-white p-1 rounded"
          />
          <label [for]="item" class="fs-6"> NFC </label>
          <!-- <div class="small-font">
            (Only Supported on Android Devices running Chrome Browser)
          </div> -->
        }
      </div>
    }
  </div>
  <div class="row row-cols-2">
    <div class="col">
      <button
        (click)="onCloseDialog(false)"
        class="btn btn-lg btn-dark btn-lg w-100"
      >
        Cancel
      </button>
    </div>

    <div class="col">
      <button
        class="btn btn-lg btn-success btn-lg w-100"
        (click)="updatePreferences()"
        [disabled]="
          scanPreferences?.scan_gps == scanPreferencesBackup?.scan_gps &&
          scanPreferences?.scan_qr == scanPreferencesBackup?.scan_qr &&
          scanPreferences?.scan_nfc == scanPreferencesBackup?.scan_nfc
        "
      >
        Update
      </button>
    </div>
  </div>
</div>
